import * as React from "react";
import isEqual from "react-fast-compare";
import { css } from "@emotion/react";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

export interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  listData: string[];
}

const DetailItemListComponent: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { listData } = props;
  return (
    <ul css={listStyle}>
      {listData.map((text: string, index: number) => {
        return (
          <li key={index} css={listItemStyle}>
            {text}
          </li>
        );
      })}
    </ul>
  );
};
const areEqual: any = (prevProps: any, nextProps: any): any => {
  return isEqual(prevProps, nextProps);
};
export const DetailItemList: any = React.memo(
  DetailItemListComponent,
  areEqual
);

const listStyle = css`
  list-style-type: square;
  margin: 0;
  padding: 0 ${space.atom} 0 2em;
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption1};
  ${moreThanBreakpoint("tablet")} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
const listItemStyle = css`
  padding: 0.32rem 0;
  line-height: ${lineHeight.caption3};
  ${moreThanBreakpoint("tablet")} {
    width: 48%;
  }
`;
